import DateRangePicker from "daterangepicker"
import { html, render } from "lit-html"
import { virtual, useState, useEffect, useRef } from "haunted"
import { ref } from "../directives"

export const DateRangeInput = virtual(({ name, id, dateRange }) => {
  const buttonRef = useRef(null)
  const inputRef = useRef(null)
  const [inputValue, setInputValue] = useState(dateRange)

  useEffect(() => {
    if (!buttonRef.current || !inputRef.current) return

    const $button = buttonRef.current
    const $input = inputRef.current

    const picker = new DateRangePicker($button, {
      autoUpdateInput: false,
      locale: { cancelLabel: "Clear" },
    })

    picker.element.on("apply.daterangepicker", (_, picker) => {
      const startDate = picker.startDate.format("MM/DD/YYYY")
      const endDate = picker.endDate.format("MM/DD/YYYY")
      setInputValue(`${startDate} - ${endDate}`)
      $input.dispatchEvent(new Event("change"))
    })

    picker.element.on("cancel.daterangepicker", () => {
      setInputValue("")
      $input.dispatchEvent(new Event("change"))
    })
  }, [])

  return html`
    <button
      class="button w-full rounded-md border-px border-gray-border min-h-40 bg-white px-4 py-0 justify-start text-black focus:outline-none hover:border-blue active:shadow-input-blue focus:shadow-input-blue"
      type="button"
      id="date-range-button"
      ?data-has-value=${inputValue !== ``}
      ?ref=${ref(buttonRef)}
      aria-label="Date range"
      @clear="${() => {
        setInputValue("")
      }}}"
    >
      ${inputValue ? `Date: ${inputValue}` : `Date: All time`}
      <i class="far fa-calendar input-icon"></i>
    </button>
    <input
      id=${id}
      name=${name}
      ?ref=${ref(inputRef)}
      type="hidden"
      .value="${inputValue}"
    />
  `
})

export default function renderDateRange(el) {
  const input = el.querySelector(`input[type='hidden']`)
  const dateRange = input.value
  render(DateRangeInput({ el, name: input.name, id: input.id, dateRange }), el)
}
